import script from "./UploadsListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadsListView.vue?vue&type=script&setup=true&lang=ts"

import "./UploadsListView.vue?vue&type=style&index=0&id=3840387a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3840387a"]])

export default __exports__